import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_DIRECCION;

/**
 * Flag que indica si el usuario tiene una sesión activa.
 * Solo se dispara 'session-expired' cuando este flag es true,
 * evitando falsos positivos en cargas frescas sin sesión.
 */
let _hasActiveSession = false;

export function setHasActiveSession(value) {
  _hasActiveSession = value;
}

/**
 * Instancia de axios configurada con la URL base, timeout y credenciales.
 * Todas las peticiones HTTP de la app deben usar esta instancia
 * para que el interceptor de 401 detecte sesiones expiradas.
 */
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Interceptor de respuesta para manejar errores de autenticación.
 * Dispara un evento 'session-expired' que es capturado por el SessionExpiredModal
 * y por el UserContext para limpiar el estado del usuario.
 *
 * Solo dispara el evento si el usuario tenía una sesión activa previamente
 * (_hasActiveSession), evitando que aparezca el modal en cargas sin sesión.
 */
axiosInstance.interceptors.response.use(
  (response) => {
    // Cada respuesta exitosa indica actividad del usuario.
    // Reiniciar el timer de inactividad en el cliente.
    if (_hasActiveSession) {
      window.dispatchEvent(new Event('session-activity'));
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Solo mostrar modal si:
      // 1. El usuario tenía una sesión activa
      // 2. No es una petición de login/register/status
      if (
        _hasActiveSession &&
        !error.config?.url?.includes('/auth/login') &&
        !error.config?.url?.includes('/auth/register') &&
        !error.config?.url?.includes('/auth/status')
      ) {
        // Disparar evento para mostrar el modal de sesión expirada
        _hasActiveSession = false;
        window.dispatchEvent(new Event('session-expired'));
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
